document.addEventListener('teeinblue-event-component-injected', function() {
  const maxCount = 30;
  let count = 0;
  const interval = setInterval(function() {
    const tibPrice = document.querySelector('.tee-product-price');
    const afterpayMessage = document.getElementById('afterpay-paragraph');
    const policies = document.querySelector('.product__policies');
    
    if (tibPrice && afterpayMessage && policies) {
      tibPrice.parentNode.insertBefore(policies, tibPrice.nextSibling);
      tibPrice.parentNode.insertBefore(afterpayMessage, tibPrice.nextSibling);

      clearInterval(interval);
    } else if (count > maxCount) {
      clearInterval(interval);
    } else {
      count += 1;
    }
  }, 100);
});